//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { ClientBase } from "./ClientBase";

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client extends ClientBase {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl ?? "";
  }

  /**
   * @return OK
   */
  testGetWhereUsed(): Promise<void> {
    let url_ = this.baseUrl + "/v1/Test";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processTestGetWhereUsed(_response);
      });
  }

  protected processTestGetWhereUsed(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return OK
   */
  infoInfo(api_version: string | undefined): Promise<InfoResult> {
    let url_ = this.baseUrl + "/api/Info?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processInfoInfo(_response);
      });
  }

  protected processInfoInfo(response: Response): Promise<InfoResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = InfoResult.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<InfoResult>(null as any);
  }

  /**
   * @param includeData (optional)
   * @return OK
   */
  assessmentGetByDataContentId(contentId: string, includeData: boolean | undefined): Promise<AssessmentDto[]> {
    let url_ = this.baseUrl + "/v1/Assessment/GetByDataContentId/{contentId}?";
    if (contentId === undefined || contentId === null) throw new Error("The parameter 'contentId' must be defined.");
    url_ = url_.replace("{contentId}", encodeURIComponent("" + contentId));
    if (includeData === null) throw new Error("The parameter 'includeData' cannot be null.");
    else if (includeData !== undefined) url_ += "includeData=" + encodeURIComponent("" + includeData) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAssessmentGetByDataContentId(_response);
      });
  }

  protected processAssessmentGetByDataContentId(response: Response): Promise<AssessmentDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(AssessmentDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<AssessmentDto[]>(null as any);
  }

  /**
   * @param name (optional)
   * @param customer (optional)
   * @param status (optional)
   * @return OK
   */
  assessmentGetAssessmentList(
    name: string | undefined,
    customer: string | undefined,
    status: number | undefined
  ): Promise<AssessmentDto[]> {
    let url_ = this.baseUrl + "/v1/Assessment?";
    if (name === null) throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined) url_ += "name=" + encodeURIComponent("" + name) + "&";
    if (customer === null) throw new Error("The parameter 'customer' cannot be null.");
    else if (customer !== undefined) url_ += "customer=" + encodeURIComponent("" + customer) + "&";
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += "status=" + encodeURIComponent("" + status) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAssessmentGetAssessmentList(_response);
      });
  }

  protected processAssessmentGetAssessmentList(response: Response): Promise<AssessmentDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(AssessmentDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<AssessmentDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  assessmentCreateAssessment(body: AssessmentDto | undefined): Promise<AssessmentDto> {
    let url_ = this.baseUrl + "/v1/Assessment";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAssessmentCreateAssessment(_response);
      });
  }

  protected processAssessmentCreateAssessment(response: Response): Promise<AssessmentDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AssessmentDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<AssessmentDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  assessmentUpdateAssessment(body: AssessmentDto | undefined): Promise<AssessmentDto> {
    let url_ = this.baseUrl + "/v1/Assessment";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAssessmentUpdateAssessment(_response);
      });
  }

  protected processAssessmentUpdateAssessment(response: Response): Promise<AssessmentDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AssessmentDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<AssessmentDto>(null as any);
  }

  /**
   * @return OK
   */
  assessmentGetAssessment(id: number): Promise<AssessmentDto> {
    let url_ = this.baseUrl + "/v1/Assessment/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAssessmentGetAssessment(_response);
      });
  }

  protected processAssessmentGetAssessment(response: Response): Promise<AssessmentDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = AssessmentDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<AssessmentDto>(null as any);
  }

  /**
   * @return OK
   */
  assessmentDeleteAssessment(id: number): Promise<boolean> {
    let url_ = this.baseUrl + "/v1/Assessment/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processAssessmentDeleteAssessment(_response);
      });
  }

  protected processAssessmentDeleteAssessment(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  /**
   * @return OK
   */
  configGet(key: string): Promise<ConfigDto> {
    let url_ = this.baseUrl + "/v1/Config/{key}";
    if (key === undefined || key === null) throw new Error("The parameter 'key' must be defined.");
    url_ = url_.replace("{key}", encodeURIComponent("" + key));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processConfigGet(_response);
      });
  }

  protected processConfigGet(response: Response): Promise<ConfigDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ConfigDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ConfigDto>(null as any);
  }

  /**
   * @param organisation (optional)
   * @return OK
   */
  consumerModelGetModel(id: number, organisation: string | undefined): Promise<ItemDto> {
    let url_ = this.baseUrl + "/v1/ConsumerModel/{id}?";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (organisation === null) throw new Error("The parameter 'organisation' cannot be null.");
    else if (organisation !== undefined) url_ += "organisation=" + encodeURIComponent("" + organisation) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processConsumerModelGetModel(_response);
      });
  }

  protected processConsumerModelGetModel(response: Response): Promise<ItemDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ItemDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ItemDto>(null as any);
  }

  /**
   * @param organisation (optional)
   * @param body (optional)
   * @return OK
   */
  consumerModelGetModelList(organisation: string | undefined, body: number[] | undefined): Promise<ItemDto> {
    let url_ = this.baseUrl + "/v1/ConsumerModel?";
    if (organisation === null) throw new Error("The parameter 'organisation' cannot be null.");
    else if (organisation !== undefined) url_ += "organisation=" + encodeURIComponent("" + organisation) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processConsumerModelGetModelList(_response);
      });
  }

  protected processConsumerModelGetModelList(response: Response): Promise<ItemDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ItemDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ItemDto>(null as any);
  }

  /**
   * @return OK
   */
  containerGet(id: number): Promise<ContainerDto> {
    let url_ = this.baseUrl + "/v1/Container/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processContainerGet(_response);
      });
  }

  protected processContainerGet(response: Response): Promise<ContainerDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ContainerDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ContainerDto>(null as any);
  }

  /**
   * @param containerTypeId (optional)
   * @return OK
   */
  containerGetContainerSubTypes(containerTypeId: number | undefined): Promise<ContainerSubTypeDto[]> {
    let url_ = this.baseUrl + "/v1/Container/GetContainerSubTypes?";
    if (containerTypeId === null) throw new Error("The parameter 'containerTypeId' cannot be null.");
    else if (containerTypeId !== undefined) url_ += "containerTypeId=" + encodeURIComponent("" + containerTypeId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processContainerGetContainerSubTypes(_response);
      });
  }

  protected processContainerGetContainerSubTypes(response: Response): Promise<ContainerSubTypeDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(ContainerSubTypeDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ContainerSubTypeDto[]>(null as any);
  }

  /**
   * @param containerId (optional)
   * @return OK
   */
  containerCopyContainer(containerId: number | undefined): Promise<ContainerDto> {
    let url_ = this.baseUrl + "/v1/Container/CopyContainer?";
    if (containerId === null) throw new Error("The parameter 'containerId' cannot be null.");
    else if (containerId !== undefined) url_ += "containerId=" + encodeURIComponent("" + containerId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processContainerCopyContainer(_response);
      });
  }

  protected processContainerCopyContainer(response: Response): Promise<ContainerDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = ContainerDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<ContainerDto>(null as any);
  }

  /**
   * @param organisation (optional)
   * @return OK
   */
  editorComponentGetComponent(id: number, organisation: string | undefined): Promise<LearningObjectStructure> {
    let url_ = this.baseUrl + "/v1/EditorComponent/{id}?";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (organisation === null) throw new Error("The parameter 'organisation' cannot be null.");
    else if (organisation !== undefined) url_ += "organisation=" + encodeURIComponent("" + organisation) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processEditorComponentGetComponent(_response);
      });
  }

  protected processEditorComponentGetComponent(response: Response): Promise<LearningObjectStructure> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = LearningObjectStructure.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<LearningObjectStructure>(null as any);
  }

  /**
   * @param lifeCycleStatus (optional)
   * @param organisation (optional)
   * @param body (optional)
   * @return OK
   */
  editorComponentUpdateComponent(
    id: number,
    lifeCycleStatus: LifeCycleStatus | undefined,
    organisation: string | undefined,
    body: LearningObjectStructure | undefined
  ): Promise<boolean> {
    let url_ = this.baseUrl + "/v1/EditorComponent/{id}?";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (lifeCycleStatus === null) throw new Error("The parameter 'lifeCycleStatus' cannot be null.");
    else if (lifeCycleStatus !== undefined) url_ += "lifeCycleStatus=" + encodeURIComponent("" + lifeCycleStatus) + "&";
    if (organisation === null) throw new Error("The parameter 'organisation' cannot be null.");
    else if (organisation !== undefined) url_ += "organisation=" + encodeURIComponent("" + organisation) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processEditorComponentUpdateComponent(_response);
      });
  }

  protected processEditorComponentUpdateComponent(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  /**
   * @param status (optional)
   * @param organisation (optional)
   * @param body (optional)
   * @return OK
   */
  editorComponentCreateComponent(
    status: LifeCycleStatus | undefined,
    organisation: string | undefined,
    body: LearningObjectStructure | undefined
  ): Promise<number> {
    let url_ = this.baseUrl + "/v1/EditorComponent?";
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += "status=" + encodeURIComponent("" + status) + "&";
    if (organisation === null) throw new Error("The parameter 'organisation' cannot be null.");
    else if (organisation !== undefined) url_ += "organisation=" + encodeURIComponent("" + organisation) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processEditorComponentCreateComponent(_response);
      });
  }

  protected processEditorComponentCreateComponent(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * @param organisation (optional)
   * @return OK
   */
  editorComponentCDSImport(organisation: string | undefined): Promise<string> {
    let url_ = this.baseUrl + "/v1/EditorComponent/CDSImport?";
    if (organisation === null) throw new Error("The parameter 'organisation' cannot be null.");
    else if (organisation !== undefined) url_ += "organisation=" + encodeURIComponent("" + organisation) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processEditorComponentCDSImport(_response);
      });
  }

  protected processEditorComponentCDSImport(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * @param id (optional)
   * @param api_version (optional)
   * @return OK
   */
  educationGetActivity(id: number | undefined, api_version: string | undefined): Promise<number> {
    let url_ = this.baseUrl + "/api/Education?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += "id=" + encodeURIComponent("" + id) + "&";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processEducationGetActivity(_response);
      });
  }

  protected processEducationGetActivity(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * @param api_version (optional)
   * @param body (optional)
   * @return OK
   */
  educationAdd(api_version: string | undefined, body: ContainerEducationRequest | undefined): Promise<number> {
    let url_ = this.baseUrl + "/api/Education?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processEducationAdd(_response);
      });
  }

  protected processEducationAdd(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * @param id (optional)
   * @param api_version (optional)
   * @return OK
   */
  educationGetMetadata(id: number | undefined, api_version: string | undefined): Promise<GetEducationMetadataResponse> {
    let url_ = this.baseUrl + "/api/Education/GetMetadata?";
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += "id=" + encodeURIComponent("" + id) + "&";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processEducationGetMetadata(_response);
      });
  }

  protected processEducationGetMetadata(response: Response): Promise<GetEducationMetadataResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetEducationMetadataResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetEducationMetadataResponse>(null as any);
  }

  /**
   * @param organisation (optional)
   * @return OK
   */
  interactionComponentGet(id: number, organisation: string | undefined): Promise<GetInteractionContainerResponse> {
    let url_ = this.baseUrl + "/v1/InteractionComponent/{id}?";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (organisation === null) throw new Error("The parameter 'organisation' cannot be null.");
    else if (organisation !== undefined) url_ += "organisation=" + encodeURIComponent("" + organisation) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processInteractionComponentGet(_response);
      });
  }

  protected processInteractionComponentGet(response: Response): Promise<GetInteractionContainerResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetInteractionContainerResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetInteractionContainerResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  interactionComponentCreateComponent(body: SaveInteractionContainerRequest | undefined): Promise<number> {
    let url_ = this.baseUrl + "/v1/InteractionComponent";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processInteractionComponentCreateComponent(_response);
      });
  }

  protected processInteractionComponentCreateComponent(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  interactionComponentUpdateComponent(body: SaveInteractionContainerRequest | undefined): Promise<boolean> {
    let url_ = this.baseUrl + "/v1/InteractionComponent";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processInteractionComponentUpdateComponent(_response);
      });
  }

  protected processInteractionComponentUpdateComponent(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  /**
   * @return OK
   */
  learningObjectGet(id: number): Promise<GetLearningObjectContainerResponse> {
    let url_ = this.baseUrl + "/v1/LearningObject/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLearningObjectGet(_response);
      });
  }

  protected processLearningObjectGet(response: Response): Promise<GetLearningObjectContainerResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetLearningObjectContainerResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetLearningObjectContainerResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  learningObjectPut(id: number, body: SaveContainerRequest | undefined): Promise<boolean> {
    let url_ = this.baseUrl + "/v1/LearningObject/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "PUT",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processLearningObjectPut(_response);
      });
  }

  protected processLearningObjectPut(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  mediaGetLatestMedia(body: GetMediaRequest | undefined): Promise<GetMediaResponse> {
    let url_ = this.baseUrl + "/v1/Media/GetLatestMedia";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMediaGetLatestMedia(_response);
      });
  }

  protected processMediaGetLatestMedia(response: Response): Promise<GetMediaResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetMediaResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetMediaResponse>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return OK
   */
  pingPing(api_version: string | undefined): Promise<PingResult> {
    let url_ = this.baseUrl + "/api/Ping?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPingPing(_response);
      });
  }

  protected processPingPing(response: Response): Promise<PingResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PingResult.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<PingResult>(null as any);
  }

  /**
   * @param api_version (optional)
   * @param body (optional)
   * @return OK
   */
  publishPublish(
    api_version: string | undefined,
    body: ContainerPublishRequest | undefined
  ): Promise<PublishContainerResponse> {
    let url_ = this.baseUrl + "/api/Publish?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPublishPublish(_response);
      });
  }

  protected processPublishPublish(response: Response): Promise<PublishContainerResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PublishContainerResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<PublishContainerResponse>(null as any);
  }

  /**
   * @param api_version (optional)
   * @param body (optional)
   * @return OK
   */
  publishValidForPublish(
    api_version: string | undefined,
    body: ContainerPublishRequest | undefined
  ): Promise<PublishValidationResponse> {
    let url_ = this.baseUrl + "/api/Publish/ValidForPublish?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPublishValidForPublish(_response);
      });
  }

  protected processPublishValidForPublish(response: Response): Promise<PublishValidationResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = PublishValidationResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<PublishValidationResponse>(null as any);
  }

  /**
   * @param contentId (optional)
   * @param api_version (optional)
   * @return OK
   */
  publishGetContainerId(contentId: string | undefined, api_version: string | undefined): Promise<number> {
    let url_ = this.baseUrl + "/api/Publish/GetContainerId?";
    if (contentId === null) throw new Error("The parameter 'contentId' cannot be null.");
    else if (contentId !== undefined) url_ += "contentId=" + encodeURIComponent("" + contentId) + "&";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPublishGetContainerId(_response);
      });
  }

  protected processPublishGetContainerId(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  settingGetLatestLearningObjects(body: GetLearningObjectRequest | undefined): Promise<GetMyLatestItemsResponse> {
    let url_ = this.baseUrl + "/v1/Setting/GetLatestLearningObjects";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSettingGetLatestLearningObjects(_response);
      });
  }

  protected processSettingGetLatestLearningObjects(response: Response): Promise<GetMyLatestItemsResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetMyLatestItemsResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetMyLatestItemsResponse>(null as any);
  }

  /**
   * @return OK
   */
  settingGetLatestQuestions(): Promise<number[]> {
    let url_ = this.baseUrl + "/v1/Setting/GetLatestQuestions";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSettingGetLatestQuestions(_response);
      });
  }

  protected processSettingGetLatestQuestions(response: Response): Promise<number[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(item);
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number[]>(null as any);
  }

  /**
   * @param questionId (optional)
   * @return OK
   */
  settingSetLatestQuestions(questionId: number | undefined): Promise<void> {
    let url_ = this.baseUrl + "/v1/Setting/SetLatestQuestions?";
    if (questionId === null) throw new Error("The parameter 'questionId' cannot be null.");
    else if (questionId !== undefined) url_ += "questionId=" + encodeURIComponent("" + questionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSettingSetLatestQuestions(_response);
      });
  }

  protected processSettingSetLatestQuestions(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param questionId (optional)
   * @return OK
   */
  settingSetLatestLearningObjects(questionId: number | undefined): Promise<void> {
    let url_ = this.baseUrl + "/v1/Setting/SetLatestLearningObjects?";
    if (questionId === null) throw new Error("The parameter 'questionId' cannot be null.");
    else if (questionId !== undefined) url_ += "questionId=" + encodeURIComponent("" + questionId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSettingSetLatestLearningObjects(_response);
      });
  }

  protected processSettingSetLatestLearningObjects(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  settingGetQuestionFilters(): Promise<CustomFilterDto[]> {
    let url_ = this.baseUrl + "/v1/Setting/GetQuestionFilters";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSettingGetQuestionFilters(_response);
      });
  }

  protected processSettingGetQuestionFilters(response: Response): Promise<CustomFilterDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(CustomFilterDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CustomFilterDto[]>(null as any);
  }

  /**
   * @return OK
   */
  settingGetLearningObjectFilters(): Promise<CustomFilterDto[]> {
    let url_ = this.baseUrl + "/v1/Setting/GetLearningObjectFilters";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSettingGetLearningObjectFilters(_response);
      });
  }

  protected processSettingGetLearningObjectFilters(response: Response): Promise<CustomFilterDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(CustomFilterDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<CustomFilterDto[]>(null as any);
  }

  /**
   * @param filterName (optional)
   * @return OK
   */
  settingDeleteQuestionFilter(filterName: string | undefined): Promise<void> {
    let url_ = this.baseUrl + "/v1/Setting/DeleteQuestionFilter?";
    if (filterName === null) throw new Error("The parameter 'filterName' cannot be null.");
    else if (filterName !== undefined) url_ += "filterName=" + encodeURIComponent("" + filterName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSettingDeleteQuestionFilter(_response);
      });
  }

  protected processSettingDeleteQuestionFilter(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param filterName (optional)
   * @return OK
   */
  settingDeleteLearningObjectFilter(filterName: string | undefined): Promise<void> {
    let url_ = this.baseUrl + "/v1/Setting/DeleteLearningObjectFilter?";
    if (filterName === null) throw new Error("The parameter 'filterName' cannot be null.");
    else if (filterName !== undefined) url_ += "filterName=" + encodeURIComponent("" + filterName) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "DELETE",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSettingDeleteLearningObjectFilter(_response);
      });
  }

  protected processSettingDeleteLearningObjectFilter(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  settingAddQuestionFilter(body: GetFilterRequest | undefined): Promise<number> {
    let url_ = this.baseUrl + "/v1/Setting/AddQuestionFilter";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSettingAddQuestionFilter(_response);
      });
  }

  protected processSettingAddQuestionFilter(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  settingAddLearningObjectFilter(body: GetFilterRequest | undefined): Promise<number> {
    let url_ = this.baseUrl + "/v1/Setting/AddLearningObjectFilter";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processSettingAddLearningObjectFilter(_response);
      });
  }

  protected processSettingAddLearningObjectFilter(response: Response): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<number>(null as any);
  }

  /**
   * @return OK
   */
  userGet(): Promise<UserDto> {
    let url_ = this.baseUrl + "/v1/User";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserGet(_response);
      });
  }

  protected processUserGet(response: Response): Promise<UserDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = UserDto.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserDto>(null as any);
  }

  /**
   * @return OK
   */
  userCreate(): Promise<void> {
    let url_ = this.baseUrl + "/v1/User/Create";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "POST",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserCreate(_response);
      });
  }

  protected processUserCreate(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @return OK
   */
  userUsers(): Promise<UserDto[]> {
    let url_ = this.baseUrl + "/v1/User/Users";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserUsers(_response);
      });
  }

  protected processUserUsers(response: Response): Promise<UserDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(UserDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<UserDto[]>(null as any);
  }

  /**
   * @param userId (optional)
   * @param groupId (optional)
   * @return OK
   */
  userIsMember(userId: number | undefined, groupId: number | undefined): Promise<boolean> {
    let url_ = this.baseUrl + "/v1/User/IsMember?";
    if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined) url_ += "userId=" + encodeURIComponent("" + userId) + "&";
    if (groupId === null) throw new Error("The parameter 'groupId' cannot be null.");
    else if (groupId !== undefined) url_ += "groupId=" + encodeURIComponent("" + groupId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserIsMember(_response);
      });
  }

  protected processUserIsMember(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  /**
   * @return OK
   */
  userIsPublisher(): Promise<boolean> {
    let url_ = this.baseUrl + "/v1/User/isPublisher";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processUserIsPublisher(_response);
      });
  }

  protected processUserIsPublisher(response: Response): Promise<boolean> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<boolean>(null as any);
  }

  /**
   * @param api_version (optional)
   * @return OK
   */
  webClientPingLearnableLearningObjectiveService(api_version: string | undefined): Promise<string> {
    let url_ = this.baseUrl + "/api/WebClient?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processWebClientPingLearnableLearningObjectiveService(_response);
      });
  }

  protected processWebClientPingLearnableLearningObjectiveService(response: Response): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;

        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<string>(null as any);
  }

  /**
   * @return OK
   */
  whereUsedGetWhereUsed(id: number): Promise<GetWhereUsedResponse> {
    let url_ = this.baseUrl + "/v1/WhereUsed/{id}";
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processWhereUsedGetWhereUsed(_response);
      });
  }

  protected processWhereUsedGetWhereUsed(response: Response): Promise<GetWhereUsedResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetWhereUsedResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetWhereUsedResponse>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  whereUsedGetWhereUsedLearningObjectImage(
    body: WhereUsedLearningObjectImageRequest | undefined
  ): Promise<WhereUsedDto[]> {
    let url_ = this.baseUrl + "/v1/WhereUsed/WhereUsedLearningObjectImage";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processWhereUsedGetWhereUsedLearningObjectImage(_response);
      });
  }

  protected processWhereUsedGetWhereUsedLearningObjectImage(response: Response): Promise<WhereUsedDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(WhereUsedDto.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<WhereUsedDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return OK
   */
  whereUsedGetWhereUsedQuestion(body: WhereUsedQuestionRequest | undefined): Promise<GetWhereUsedResponse> {
    let url_ = this.baseUrl + "/v1/WhereUsed/WhereUsedQuestion";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: RequestInit = {
      body: content_,
      method: "POST",
      headers: {
        "Content-Type": "application/json-patch+json",
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processWhereUsedGetWhereUsedQuestion(_response);
      });
  }

  protected processWhereUsedGetWhereUsedQuestion(response: Response): Promise<GetWhereUsedResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetWhereUsedResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetWhereUsedResponse>(null as any);
  }
}

export class Assessment implements IAssessment {
  reference?: Reference;

  constructor(data?: IAssessment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reference = _data["reference"] ? Reference.fromJS(_data["reference"]) : <any>undefined;
    }
  }

  static fromJS(data: any): Assessment {
    data = typeof data === "object" ? data : {};
    let result = new Assessment();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["reference"] = this.reference ? this.reference.toJSON() : <any>undefined;
    return data;
  }
}

export interface IAssessment {
  reference?: Reference;
}

export class AssessmentDto implements IAssessmentDto {
  id?: number;
  name?: string | undefined;
  description?: string | undefined;
  statusId?: number;
  customerId?: string;
  contentId?: string | undefined;
  versionId?: string | undefined;
  semanticVersion?: string | undefined;
  dirty?: boolean;
  data?: string | undefined;

  constructor(data?: IAssessmentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.description = _data["description"];
      this.statusId = _data["statusId"];
      this.customerId = _data["customerId"];
      this.contentId = _data["contentId"];
      this.versionId = _data["versionId"];
      this.semanticVersion = _data["semanticVersion"];
      this.dirty = _data["dirty"];
      this.data = _data["data"];
    }
  }

  static fromJS(data: any): AssessmentDto {
    data = typeof data === "object" ? data : {};
    let result = new AssessmentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["description"] = this.description;
    data["statusId"] = this.statusId;
    data["customerId"] = this.customerId;
    data["contentId"] = this.contentId;
    data["versionId"] = this.versionId;
    data["semanticVersion"] = this.semanticVersion;
    data["dirty"] = this.dirty;
    data["data"] = this.data;
    return data;
  }
}

export interface IAssessmentDto {
  id?: number;
  name?: string | undefined;
  description?: string | undefined;
  statusId?: number;
  customerId?: string;
  contentId?: string | undefined;
  versionId?: string | undefined;
  semanticVersion?: string | undefined;
  dirty?: boolean;
  data?: string | undefined;
}

export class CDSMetadata implements ICDSMetadata {
  reference?: Reference;
  created?: Date;

  constructor(data?: ICDSMetadata) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.reference = _data["reference"] ? Reference.fromJS(_data["reference"]) : <any>undefined;
      this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): CDSMetadata {
    data = typeof data === "object" ? data : {};
    let result = new CDSMetadata();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["reference"] = this.reference ? this.reference.toJSON() : <any>undefined;
    data["created"] = this.created ? this.created.toISOString() : <any>undefined;
    return data;
  }
}

export interface ICDSMetadata {
  reference?: Reference;
  created?: Date;
}

export class Carousel implements ICarousel {
  items?: CarouselItem[] | undefined;

  constructor(data?: ICarousel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items!.push(CarouselItem.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Carousel {
    data = typeof data === "object" ? data : {};
    let result = new Carousel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICarousel {
  items?: CarouselItem[] | undefined;
}

export class CarouselItem implements ICarouselItem {
  text?: string | undefined;
  image?: Image;
  sortorder?: number;

  constructor(data?: ICarouselItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.text = _data["text"];
      this.image = _data["image"] ? Image.fromJS(_data["image"]) : <any>undefined;
      this.sortorder = _data["sortorder"];
    }
  }

  static fromJS(data: any): CarouselItem {
    data = typeof data === "object" ? data : {};
    let result = new CarouselItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["text"] = this.text;
    data["image"] = this.image ? this.image.toJSON() : <any>undefined;
    data["sortorder"] = this.sortorder;
    return data;
  }
}

export interface ICarouselItem {
  text?: string | undefined;
  image?: Image;
  sortorder?: number;
}

export class Component implements IComponent {
  sortOrder?: number;
  componentType?: string | undefined;
  header?: Header;
  html?: string | undefined;
  list?: string | undefined;
  image?: Image;
  video?: Video;
  interactiveVideo?: InteractiveVideo;
  informationBox?: Informationbox;
  interaction?: Interaction;
  carousel?: Carousel;
  assessment?: Assessment;

  constructor(data?: IComponent) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sortOrder = _data["sortOrder"];
      this.componentType = _data["componentType"];
      this.header = _data["header"] ? Header.fromJS(_data["header"]) : <any>undefined;
      this.html = _data["html"];
      this.list = _data["list"];
      this.image = _data["image"] ? Image.fromJS(_data["image"]) : <any>undefined;
      this.video = _data["video"] ? Video.fromJS(_data["video"]) : <any>undefined;
      this.interactiveVideo = _data["interactiveVideo"]
        ? InteractiveVideo.fromJS(_data["interactiveVideo"])
        : <any>undefined;
      this.informationBox = _data["informationBox"] ? Informationbox.fromJS(_data["informationBox"]) : <any>undefined;
      this.interaction = _data["interaction"] ? Interaction.fromJS(_data["interaction"]) : <any>undefined;
      this.carousel = _data["carousel"] ? Carousel.fromJS(_data["carousel"]) : <any>undefined;
      this.assessment = _data["assessment"] ? Assessment.fromJS(_data["assessment"]) : <any>undefined;
    }
  }

  static fromJS(data: any): Component {
    data = typeof data === "object" ? data : {};
    let result = new Component();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["sortOrder"] = this.sortOrder;
    data["componentType"] = this.componentType;
    data["header"] = this.header ? this.header.toJSON() : <any>undefined;
    data["html"] = this.html;
    data["list"] = this.list;
    data["image"] = this.image ? this.image.toJSON() : <any>undefined;
    data["video"] = this.video ? this.video.toJSON() : <any>undefined;
    data["interactiveVideo"] = this.interactiveVideo ? this.interactiveVideo.toJSON() : <any>undefined;
    data["informationBox"] = this.informationBox ? this.informationBox.toJSON() : <any>undefined;
    data["interaction"] = this.interaction ? this.interaction.toJSON() : <any>undefined;
    data["carousel"] = this.carousel ? this.carousel.toJSON() : <any>undefined;
    data["assessment"] = this.assessment ? this.assessment.toJSON() : <any>undefined;
    return data;
  }
}

export interface IComponent {
  sortOrder?: number;
  componentType?: string | undefined;
  header?: Header;
  html?: string | undefined;
  list?: string | undefined;
  image?: Image;
  video?: Video;
  interactiveVideo?: InteractiveVideo;
  informationBox?: Informationbox;
  interaction?: Interaction;
  carousel?: Carousel;
  assessment?: Assessment;
}

export class ConfigDto implements IConfigDto {
  key?: string | undefined;
  value?: string | undefined;

  constructor(data?: IConfigDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data["key"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): ConfigDto {
    data = typeof data === "object" ? data : {};
    let result = new ConfigDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["key"] = this.key;
    data["value"] = this.value;
    return data;
  }
}

export interface IConfigDto {
  key?: string | undefined;
  value?: string | undefined;
}

export class ContainerClassificationDto implements IContainerClassificationDto {
  containerId?: number;
  classificationId?: string;
  classificationRoot?: string | undefined;

  constructor(data?: IContainerClassificationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.containerId = _data["containerId"];
      this.classificationId = _data["classificationId"];
      this.classificationRoot = _data["classificationRoot"];
    }
  }

  static fromJS(data: any): ContainerClassificationDto {
    data = typeof data === "object" ? data : {};
    let result = new ContainerClassificationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["containerId"] = this.containerId;
    data["classificationId"] = this.classificationId;
    data["classificationRoot"] = this.classificationRoot;
    return data;
  }
}

export interface IContainerClassificationDto {
  containerId?: number;
  classificationId?: string;
  classificationRoot?: string | undefined;
}

export class ContainerDto implements IContainerDto {
  id!: number;
  friendlyId?: string | undefined;
  title?: string | undefined;
  description?: string | undefined;
  lifeCycleStatus?: number;
  deprecated?: boolean;
  comment?: string | undefined;
  created?: Date;
  createdBy?: string | undefined;
  updated?: Date | undefined;
  updatedBy?: string | undefined;
  parentId?: number;
  sortOrder?: number;
  children?: { [key: string]: number } | undefined;
  containerType!: number;
  containerSubType!: number;
  customerDto!: CustomerDto;
  rights?: number;
  mediaObjectDto?: MediaObjectDto;
  textObjectDto?: TextObjectDto;
  questionObjectDto?: QuestionObjectDto;
  learningObjectDto?: LearningObjectDto;
  interactionResponseObjectDto?: InteractionResponseObjectDto;
  level!: number;
  publishStatus?: number;
  contentId?: string | undefined;
  versionId?: string | undefined;
  semanticVersion?: string | undefined;
  containerClassificationDtos?: ContainerClassificationDto[] | undefined;
  containerLearningObjectiveDtos?: ContainerLearningObjectiveDto[] | undefined;
  assessmentDtos?: AssessmentDto[] | undefined;

  constructor(data?: IContainerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.customerDto = new CustomerDto();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.friendlyId = _data["friendlyId"];
      this.title = _data["title"];
      this.description = _data["description"];
      this.lifeCycleStatus = _data["lifeCycleStatus"];
      this.deprecated = _data["deprecated"];
      this.comment = _data["comment"];
      this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
      this.createdBy = _data["createdBy"];
      this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
      this.updatedBy = _data["updatedBy"];
      this.parentId = _data["parentId"];
      this.sortOrder = _data["sortOrder"];
      if (_data["children"]) {
        this.children = {} as any;
        for (let key in _data["children"]) {
          if (_data["children"].hasOwnProperty(key)) (<any>this.children)![key] = _data["children"][key];
        }
      }
      this.containerType = _data["containerType"];
      this.containerSubType = _data["containerSubType"];
      this.customerDto = _data["customerDto"] ? CustomerDto.fromJS(_data["customerDto"]) : new CustomerDto();
      this.rights = _data["rights"];
      this.mediaObjectDto = _data["mediaObjectDto"] ? MediaObjectDto.fromJS(_data["mediaObjectDto"]) : <any>undefined;
      this.textObjectDto = _data["textObjectDto"] ? TextObjectDto.fromJS(_data["textObjectDto"]) : <any>undefined;
      this.questionObjectDto = _data["questionObjectDto"]
        ? QuestionObjectDto.fromJS(_data["questionObjectDto"])
        : <any>undefined;
      this.learningObjectDto = _data["learningObjectDto"]
        ? LearningObjectDto.fromJS(_data["learningObjectDto"])
        : <any>undefined;
      this.interactionResponseObjectDto = _data["interactionResponseObjectDto"]
        ? InteractionResponseObjectDto.fromJS(_data["interactionResponseObjectDto"])
        : <any>undefined;
      this.level = _data["level"];
      this.publishStatus = _data["publishStatus"];
      this.contentId = _data["contentId"];
      this.versionId = _data["versionId"];
      this.semanticVersion = _data["semanticVersion"];
      if (Array.isArray(_data["containerClassificationDtos"])) {
        this.containerClassificationDtos = [] as any;
        for (let item of _data["containerClassificationDtos"])
          this.containerClassificationDtos!.push(ContainerClassificationDto.fromJS(item));
      }
      if (Array.isArray(_data["containerLearningObjectiveDtos"])) {
        this.containerLearningObjectiveDtos = [] as any;
        for (let item of _data["containerLearningObjectiveDtos"])
          this.containerLearningObjectiveDtos!.push(ContainerLearningObjectiveDto.fromJS(item));
      }
      if (Array.isArray(_data["assessmentDtos"])) {
        this.assessmentDtos = [] as any;
        for (let item of _data["assessmentDtos"]) this.assessmentDtos!.push(AssessmentDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ContainerDto {
    data = typeof data === "object" ? data : {};
    let result = new ContainerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["friendlyId"] = this.friendlyId;
    data["title"] = this.title;
    data["description"] = this.description;
    data["lifeCycleStatus"] = this.lifeCycleStatus;
    data["deprecated"] = this.deprecated;
    data["comment"] = this.comment;
    data["created"] = this.created ? this.created.toISOString() : <any>undefined;
    data["createdBy"] = this.createdBy;
    data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
    data["updatedBy"] = this.updatedBy;
    data["parentId"] = this.parentId;
    data["sortOrder"] = this.sortOrder;
    if (this.children) {
      data["children"] = {};
      for (let key in this.children) {
        if (this.children.hasOwnProperty(key)) (<any>data["children"])[key] = (<any>this.children)[key];
      }
    }
    data["containerType"] = this.containerType;
    data["containerSubType"] = this.containerSubType;
    data["customerDto"] = this.customerDto ? this.customerDto.toJSON() : <any>undefined;
    data["rights"] = this.rights;
    data["mediaObjectDto"] = this.mediaObjectDto ? this.mediaObjectDto.toJSON() : <any>undefined;
    data["textObjectDto"] = this.textObjectDto ? this.textObjectDto.toJSON() : <any>undefined;
    data["questionObjectDto"] = this.questionObjectDto ? this.questionObjectDto.toJSON() : <any>undefined;
    data["learningObjectDto"] = this.learningObjectDto ? this.learningObjectDto.toJSON() : <any>undefined;
    data["interactionResponseObjectDto"] = this.interactionResponseObjectDto
      ? this.interactionResponseObjectDto.toJSON()
      : <any>undefined;
    data["level"] = this.level;
    data["publishStatus"] = this.publishStatus;
    data["contentId"] = this.contentId;
    data["versionId"] = this.versionId;
    data["semanticVersion"] = this.semanticVersion;
    if (Array.isArray(this.containerClassificationDtos)) {
      data["containerClassificationDtos"] = [];
      for (let item of this.containerClassificationDtos) data["containerClassificationDtos"].push(item.toJSON());
    }
    if (Array.isArray(this.containerLearningObjectiveDtos)) {
      data["containerLearningObjectiveDtos"] = [];
      for (let item of this.containerLearningObjectiveDtos) data["containerLearningObjectiveDtos"].push(item.toJSON());
    }
    if (Array.isArray(this.assessmentDtos)) {
      data["assessmentDtos"] = [];
      for (let item of this.assessmentDtos) data["assessmentDtos"].push(item.toJSON());
    }
    return data;
  }
}

export interface IContainerDto {
  id: number;
  friendlyId?: string | undefined;
  title?: string | undefined;
  description?: string | undefined;
  lifeCycleStatus?: number;
  deprecated?: boolean;
  comment?: string | undefined;
  created?: Date;
  createdBy?: string | undefined;
  updated?: Date | undefined;
  updatedBy?: string | undefined;
  parentId?: number;
  sortOrder?: number;
  children?: { [key: string]: number } | undefined;
  containerType: number;
  containerSubType: number;
  customerDto: CustomerDto;
  rights?: number;
  mediaObjectDto?: MediaObjectDto;
  textObjectDto?: TextObjectDto;
  questionObjectDto?: QuestionObjectDto;
  learningObjectDto?: LearningObjectDto;
  interactionResponseObjectDto?: InteractionResponseObjectDto;
  level: number;
  publishStatus?: number;
  contentId?: string | undefined;
  versionId?: string | undefined;
  semanticVersion?: string | undefined;
  containerClassificationDtos?: ContainerClassificationDto[] | undefined;
  containerLearningObjectiveDtos?: ContainerLearningObjectiveDto[] | undefined;
  assessmentDtos?: AssessmentDto[] | undefined;
}

export class ContainerEducationRequest implements IContainerEducationRequest {
  title?: string | undefined;
  classificationIds?: string[] | undefined;

  constructor(data?: IContainerEducationRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data["title"];
      if (Array.isArray(_data["classificationIds"])) {
        this.classificationIds = [] as any;
        for (let item of _data["classificationIds"]) this.classificationIds!.push(item);
      }
    }
  }

  static fromJS(data: any): ContainerEducationRequest {
    data = typeof data === "object" ? data : {};
    let result = new ContainerEducationRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["title"] = this.title;
    if (Array.isArray(this.classificationIds)) {
      data["classificationIds"] = [];
      for (let item of this.classificationIds) data["classificationIds"].push(item);
    }
    return data;
  }
}

export interface IContainerEducationRequest {
  title?: string | undefined;
  classificationIds?: string[] | undefined;
}

export class ContainerLearningObjectiveDto implements IContainerLearningObjectiveDto {
  containerId?: number;
  learningObjectiveId?: string;

  constructor(data?: IContainerLearningObjectiveDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.containerId = _data["containerId"];
      this.learningObjectiveId = _data["learningObjectiveId"];
    }
  }

  static fromJS(data: any): ContainerLearningObjectiveDto {
    data = typeof data === "object" ? data : {};
    let result = new ContainerLearningObjectiveDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["containerId"] = this.containerId;
    data["learningObjectiveId"] = this.learningObjectiveId;
    return data;
  }
}

export interface IContainerLearningObjectiveDto {
  containerId?: number;
  learningObjectiveId?: string;
}

export class ContainerPublishRequest implements IContainerPublishRequest {
  containerId?: number;
  semanticVersion?: string | undefined;
  ignoreValidation?: boolean;
  owner?: string | undefined;
  origin?: string | undefined;

  constructor(data?: IContainerPublishRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.containerId = _data["containerId"];
      this.semanticVersion = _data["semanticVersion"];
      this.ignoreValidation = _data["ignoreValidation"];
      this.owner = _data["owner"];
      this.origin = _data["origin"];
    }
  }

  static fromJS(data: any): ContainerPublishRequest {
    data = typeof data === "object" ? data : {};
    let result = new ContainerPublishRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["containerId"] = this.containerId;
    data["semanticVersion"] = this.semanticVersion;
    data["ignoreValidation"] = this.ignoreValidation;
    data["owner"] = this.owner;
    data["origin"] = this.origin;
    return data;
  }
}

export interface IContainerPublishRequest {
  containerId?: number;
  semanticVersion?: string | undefined;
  ignoreValidation?: boolean;
  owner?: string | undefined;
  origin?: string | undefined;
}

export class ContainerSubTypeDto implements IContainerSubTypeDto {
  id?: number;
  name?: string | undefined;

  constructor(data?: IContainerSubTypeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): ContainerSubTypeDto {
    data = typeof data === "object" ? data : {};
    let result = new ContainerSubTypeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

export interface IContainerSubTypeDto {
  id?: number;
  name?: string | undefined;
}

export enum ContainerSubTypeInteraction {
  _0 = 0,
  _1 = 1,
  _2 = 2,
}

export enum ContainerSubTypeLearningObject {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
}

export class CustomFilterDto implements ICustomFilterDto {
  name?: string | undefined;
  containerSubType?: number | undefined;
  interaktionstypId?: number | undefined;
  templateId?: number | undefined;
  organistaionsId?: string | undefined;
  harVideo?: boolean;
  harBild?: boolean;
  ingenMedia?: boolean;
  fragetypGuids?: string[] | undefined;
  amneGuids?: string[] | undefined;
  behorighetGuids?: string[] | undefined;
  larandemalGuids?: string[] | undefined;
  fritext?: string | undefined;
  endastFragetext?: boolean;
  endastOpublicerade?: boolean;
  includeDeprecated?: boolean;

  constructor(data?: ICustomFilterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.containerSubType = _data["containerSubType"];
      this.interaktionstypId = _data["interaktionstypId"];
      this.templateId = _data["templateId"];
      this.organistaionsId = _data["organistaionsId"];
      this.harVideo = _data["harVideo"];
      this.harBild = _data["harBild"];
      this.ingenMedia = _data["ingenMedia"];
      if (Array.isArray(_data["fragetypGuids"])) {
        this.fragetypGuids = [] as any;
        for (let item of _data["fragetypGuids"]) this.fragetypGuids!.push(item);
      }
      if (Array.isArray(_data["amneGuids"])) {
        this.amneGuids = [] as any;
        for (let item of _data["amneGuids"]) this.amneGuids!.push(item);
      }
      if (Array.isArray(_data["behorighetGuids"])) {
        this.behorighetGuids = [] as any;
        for (let item of _data["behorighetGuids"]) this.behorighetGuids!.push(item);
      }
      if (Array.isArray(_data["larandemalGuids"])) {
        this.larandemalGuids = [] as any;
        for (let item of _data["larandemalGuids"]) this.larandemalGuids!.push(item);
      }
      this.fritext = _data["fritext"];
      this.endastFragetext = _data["endastFragetext"];
      this.endastOpublicerade = _data["endastOpublicerade"];
      this.includeDeprecated = _data["includeDeprecated"];
    }
  }

  static fromJS(data: any): CustomFilterDto {
    data = typeof data === "object" ? data : {};
    let result = new CustomFilterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["containerSubType"] = this.containerSubType;
    data["interaktionstypId"] = this.interaktionstypId;
    data["templateId"] = this.templateId;
    data["organistaionsId"] = this.organistaionsId;
    data["harVideo"] = this.harVideo;
    data["harBild"] = this.harBild;
    data["ingenMedia"] = this.ingenMedia;
    if (Array.isArray(this.fragetypGuids)) {
      data["fragetypGuids"] = [];
      for (let item of this.fragetypGuids) data["fragetypGuids"].push(item);
    }
    if (Array.isArray(this.amneGuids)) {
      data["amneGuids"] = [];
      for (let item of this.amneGuids) data["amneGuids"].push(item);
    }
    if (Array.isArray(this.behorighetGuids)) {
      data["behorighetGuids"] = [];
      for (let item of this.behorighetGuids) data["behorighetGuids"].push(item);
    }
    if (Array.isArray(this.larandemalGuids)) {
      data["larandemalGuids"] = [];
      for (let item of this.larandemalGuids) data["larandemalGuids"].push(item);
    }
    data["fritext"] = this.fritext;
    data["endastFragetext"] = this.endastFragetext;
    data["endastOpublicerade"] = this.endastOpublicerade;
    data["includeDeprecated"] = this.includeDeprecated;
    return data;
  }
}

export interface ICustomFilterDto {
  name?: string | undefined;
  containerSubType?: number | undefined;
  interaktionstypId?: number | undefined;
  templateId?: number | undefined;
  organistaionsId?: string | undefined;
  harVideo?: boolean;
  harBild?: boolean;
  ingenMedia?: boolean;
  fragetypGuids?: string[] | undefined;
  amneGuids?: string[] | undefined;
  behorighetGuids?: string[] | undefined;
  larandemalGuids?: string[] | undefined;
  fritext?: string | undefined;
  endastFragetext?: boolean;
  endastOpublicerade?: boolean;
  includeDeprecated?: boolean;
}

export class CustomerDto implements ICustomerDto {
  id!: string;
  name!: string;

  constructor(data?: ICustomerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): CustomerDto {
    data = typeof data === "object" ? data : {};
    let result = new CustomerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

export interface ICustomerDto {
  id: string;
  name: string;
}

export class FacetDto implements IFacetDto {
  pageInfoDto?: PageInfoDto;

  constructor(data?: IFacetDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pageInfoDto = _data["pageInfoDto"] ? PageInfoDto.fromJS(_data["pageInfoDto"]) : <any>undefined;
    }
  }

  static fromJS(data: any): FacetDto {
    data = typeof data === "object" ? data : {};
    let result = new FacetDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["pageInfoDto"] = this.pageInfoDto ? this.pageInfoDto.toJSON() : <any>undefined;
    return data;
  }
}

export interface IFacetDto {
  pageInfoDto?: PageInfoDto;
}

export class GetEducationMetadataResponse implements IGetEducationMetadataResponse {
  statusId?: number | undefined;
  createdBy?: string | undefined;
  createdDate?: Date;
  updatedBy?: string | undefined;
  updatedDate?: Date | undefined;
  customerName?: string | undefined;

  constructor(data?: IGetEducationMetadataResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.statusId = _data["statusId"];
      this.createdBy = _data["createdBy"];
      this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
      this.updatedBy = _data["updatedBy"];
      this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>undefined;
      this.customerName = _data["customerName"];
    }
  }

  static fromJS(data: any): GetEducationMetadataResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetEducationMetadataResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["statusId"] = this.statusId;
    data["createdBy"] = this.createdBy;
    data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
    data["updatedBy"] = this.updatedBy;
    data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>undefined;
    data["customerName"] = this.customerName;
    return data;
  }
}

export interface IGetEducationMetadataResponse {
  statusId?: number | undefined;
  createdBy?: string | undefined;
  createdDate?: Date;
  updatedBy?: string | undefined;
  updatedDate?: Date | undefined;
  customerName?: string | undefined;
}

export class GetFilterRequest implements IGetFilterRequest {
  customQuestionFilterDto?: CustomFilterDto;

  constructor(data?: IGetFilterRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.customQuestionFilterDto = _data["customQuestionFilterDto"]
        ? CustomFilterDto.fromJS(_data["customQuestionFilterDto"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): GetFilterRequest {
    data = typeof data === "object" ? data : {};
    let result = new GetFilterRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["customQuestionFilterDto"] = this.customQuestionFilterDto
      ? this.customQuestionFilterDto.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IGetFilterRequest {
  customQuestionFilterDto?: CustomFilterDto;
}

export class GetInteractionContainerResponse implements IGetInteractionContainerResponse {
  interactionContainer?: ContainerDto;
  interactionStructure?: InteractionStructure;

  constructor(data?: IGetInteractionContainerResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.interactionContainer = _data["interactionContainer"]
        ? ContainerDto.fromJS(_data["interactionContainer"])
        : <any>undefined;
      this.interactionStructure = _data["interactionStructure"]
        ? InteractionStructure.fromJS(_data["interactionStructure"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): GetInteractionContainerResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetInteractionContainerResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["interactionContainer"] = this.interactionContainer ? this.interactionContainer.toJSON() : <any>undefined;
    data["interactionStructure"] = this.interactionStructure ? this.interactionStructure.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetInteractionContainerResponse {
  interactionContainer?: ContainerDto;
  interactionStructure?: InteractionStructure;
}

export class GetLearningObjectContainerResponse implements IGetLearningObjectContainerResponse {
  learningObjectContainer?: ContainerDto;
  learningObjectStructure?: LearningObjectStructure;

  constructor(data?: IGetLearningObjectContainerResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.learningObjectContainer = _data["learningObjectContainer"]
        ? ContainerDto.fromJS(_data["learningObjectContainer"])
        : <any>undefined;
      this.learningObjectStructure = _data["learningObjectStructure"]
        ? LearningObjectStructure.fromJS(_data["learningObjectStructure"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): GetLearningObjectContainerResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetLearningObjectContainerResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["learningObjectContainer"] = this.learningObjectContainer
      ? this.learningObjectContainer.toJSON()
      : <any>undefined;
    data["learningObjectStructure"] = this.learningObjectStructure
      ? this.learningObjectStructure.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IGetLearningObjectContainerResponse {
  learningObjectContainer?: ContainerDto;
  learningObjectStructure?: LearningObjectStructure;
}

export class GetLearningObjectRequest implements IGetLearningObjectRequest {
  cultureName?: string | undefined;
  maxRows?: number;
  facetDto?: FacetDto;

  constructor(data?: IGetLearningObjectRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.cultureName = _data["cultureName"];
      this.maxRows = _data["maxRows"];
      this.facetDto = _data["facetDto"] ? FacetDto.fromJS(_data["facetDto"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetLearningObjectRequest {
    data = typeof data === "object" ? data : {};
    let result = new GetLearningObjectRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["cultureName"] = this.cultureName;
    data["maxRows"] = this.maxRows;
    data["facetDto"] = this.facetDto ? this.facetDto.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetLearningObjectRequest {
  cultureName?: string | undefined;
  maxRows?: number;
  facetDto?: FacetDto;
}

export class GetMediaRequest implements IGetMediaRequest {
  maxRows?: number;
  facetDto?: FacetDto;

  constructor(data?: IGetMediaRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.maxRows = _data["maxRows"];
      this.facetDto = _data["facetDto"] ? FacetDto.fromJS(_data["facetDto"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetMediaRequest {
    data = typeof data === "object" ? data : {};
    let result = new GetMediaRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["maxRows"] = this.maxRows;
    data["facetDto"] = this.facetDto ? this.facetDto.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetMediaRequest {
  maxRows?: number;
  facetDto?: FacetDto;
}

export class GetMediaResponse implements IGetMediaResponse {
  mediaDtos?: MyLatestItemDto[] | undefined;
  facetDto?: FacetDto;

  constructor(data?: IGetMediaResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["mediaDtos"])) {
        this.mediaDtos = [] as any;
        for (let item of _data["mediaDtos"]) this.mediaDtos!.push(MyLatestItemDto.fromJS(item));
      }
      this.facetDto = _data["facetDto"] ? FacetDto.fromJS(_data["facetDto"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetMediaResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetMediaResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.mediaDtos)) {
      data["mediaDtos"] = [];
      for (let item of this.mediaDtos) data["mediaDtos"].push(item.toJSON());
    }
    data["facetDto"] = this.facetDto ? this.facetDto.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetMediaResponse {
  mediaDtos?: MyLatestItemDto[] | undefined;
  facetDto?: FacetDto;
}

export class GetMyLatestItemsResponse implements IGetMyLatestItemsResponse {
  myLatestItemDtos?: MyLatestItemDto[] | undefined;
  facetDto?: FacetDto;

  constructor(data?: IGetMyLatestItemsResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["myLatestItemDtos"])) {
        this.myLatestItemDtos = [] as any;
        for (let item of _data["myLatestItemDtos"]) this.myLatestItemDtos!.push(MyLatestItemDto.fromJS(item));
      }
      this.facetDto = _data["facetDto"] ? FacetDto.fromJS(_data["facetDto"]) : <any>undefined;
    }
  }

  static fromJS(data: any): GetMyLatestItemsResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetMyLatestItemsResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.myLatestItemDtos)) {
      data["myLatestItemDtos"] = [];
      for (let item of this.myLatestItemDtos) data["myLatestItemDtos"].push(item.toJSON());
    }
    data["facetDto"] = this.facetDto ? this.facetDto.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGetMyLatestItemsResponse {
  myLatestItemDtos?: MyLatestItemDto[] | undefined;
  facetDto?: FacetDto;
}

export class GetWhereUsedResponse implements IGetWhereUsedResponse {
  id?: number;
  used?: WhereUsedDto[] | undefined;

  constructor(data?: IGetWhereUsedResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      if (Array.isArray(_data["used"])) {
        this.used = [] as any;
        for (let item of _data["used"]) this.used!.push(WhereUsedDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetWhereUsedResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetWhereUsedResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    if (Array.isArray(this.used)) {
      data["used"] = [];
      for (let item of this.used) data["used"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetWhereUsedResponse {
  id?: number;
  used?: WhereUsedDto[] | undefined;
}

export class GroupDto implements IGroupDto {
  id?: number;
  name?: string | undefined;
  customerDto!: CustomerDto;

  constructor(data?: IGroupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.customerDto = new CustomerDto();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.customerDto = _data["customerDto"] ? CustomerDto.fromJS(_data["customerDto"]) : new CustomerDto();
    }
  }

  static fromJS(data: any): GroupDto {
    data = typeof data === "object" ? data : {};
    let result = new GroupDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["customerDto"] = this.customerDto ? this.customerDto.toJSON() : <any>undefined;
    return data;
  }
}

export interface IGroupDto {
  id?: number;
  name?: string | undefined;
  customerDto: CustomerDto;
}

export class Header implements IHeader {
  level?: number;
  text?: string | undefined;

  constructor(data?: IHeader) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.level = _data["level"];
      this.text = _data["text"];
    }
  }

  static fromJS(data: any): Header {
    data = typeof data === "object" ? data : {};
    let result = new Header();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["level"] = this.level;
    data["text"] = this.text;
    return data;
  }
}

export interface IHeader {
  level?: number;
  text?: string | undefined;
}

export class Image implements IImage {
  link?: string | undefined;
  imageText?: string | undefined;
  fileName?: string | undefined;
  deprecated?: boolean;

  constructor(data?: IImage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.link = _data["link"];
      this.imageText = _data["imageText"];
      this.fileName = _data["fileName"];
      this.deprecated = _data["deprecated"];
    }
  }

  static fromJS(data: any): Image {
    data = typeof data === "object" ? data : {};
    let result = new Image();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["link"] = this.link;
    data["imageText"] = this.imageText;
    data["fileName"] = this.fileName;
    data["deprecated"] = this.deprecated;
    return data;
  }
}

export interface IImage {
  link?: string | undefined;
  imageText?: string | undefined;
  fileName?: string | undefined;
}

export class InfoResult implements IInfoResult {
  dbName?: string | undefined;

  constructor(data?: IInfoResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dbName = _data["dbName"];
    }
  }

  static fromJS(data: any): InfoResult {
    data = typeof data === "object" ? data : {};
    let result = new InfoResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dbName"] = this.dbName;
    return data;
  }
}

export interface IInfoResult {
  dbName?: string | undefined;
}

export class Informationbox implements IInformationbox {
  title?: string | undefined;
  text?: string | undefined;

  constructor(data?: IInformationbox) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.title = _data["title"];
      this.text = _data["text"];
    }
  }

  static fromJS(data: any): Informationbox {
    data = typeof data === "object" ? data : {};
    let result = new Informationbox();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["title"] = this.title;
    data["text"] = this.text;
    return data;
  }
}

export interface IInformationbox {
  title?: string | undefined;
  text?: string | undefined;
}

export class Interaction implements IInteraction {
  id?: number;
  title?: string | undefined;
  description?: string | undefined;
  subtype?: ContainerSubTypeInteraction;
  questionid?: number;

  constructor(data?: IInteraction) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.title = _data["title"];
      this.description = _data["description"];
      this.subtype = _data["subtype"];
      this.questionid = _data["questionid"];
    }
  }

  static fromJS(data: any): Interaction {
    data = typeof data === "object" ? data : {};
    let result = new Interaction();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["title"] = this.title;
    data["description"] = this.description;
    data["subtype"] = this.subtype;
    data["questionid"] = this.questionid;
    return data;
  }
}

export interface IInteraction {
  id?: number;
  title?: string | undefined;
  description?: string | undefined;
  subtype?: ContainerSubTypeInteraction;
  questionid?: number;
}

export class InteractionResponse implements IInteractionResponse {
  id?: number;
  subType?: number;
  optionId?: string | undefined;
  components?: Component[] | undefined;

  constructor(data?: IInteractionResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.subType = _data["subType"];
      this.optionId = _data["optionId"];
      if (Array.isArray(_data["components"])) {
        this.components = [] as any;
        for (let item of _data["components"]) this.components!.push(Component.fromJS(item));
      }
    }
  }

  static fromJS(data: any): InteractionResponse {
    data = typeof data === "object" ? data : {};
    let result = new InteractionResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["subType"] = this.subType;
    data["optionId"] = this.optionId;
    if (Array.isArray(this.components)) {
      data["components"] = [];
      for (let item of this.components) data["components"].push(item.toJSON());
    }
    return data;
  }
}

export interface IInteractionResponse {
  id?: number;
  subType?: number;
  optionId?: string | undefined;
  components?: Component[] | undefined;
}

export class InteractionResponseObjectDto implements IInteractionResponseObjectDto {
  id!: number;
  responseType!: number;
  optionKey!: string;

  constructor(data?: IInteractionResponseObjectDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.responseType = _data["responseType"];
      this.optionKey = _data["optionKey"];
    }
  }

  static fromJS(data: any): InteractionResponseObjectDto {
    data = typeof data === "object" ? data : {};
    let result = new InteractionResponseObjectDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["responseType"] = this.responseType;
    data["optionKey"] = this.optionKey;
    return data;
  }
}

export interface IInteractionResponseObjectDto {
  id: number;
  responseType: number;
  optionKey: string;
}

export class InteractionStructure implements IInteractionStructure {
  id?: number;
  title?: string | undefined;
  description?: string | undefined;
  subType?: number;
  questionid?: number;
  success?: InteractionResponse;
  failure?: InteractionResponse;
  options?: InteractionResponse[] | undefined;

  constructor(data?: IInteractionStructure) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.title = _data["title"];
      this.description = _data["description"];
      this.subType = _data["subType"];
      this.questionid = _data["questionid"];
      this.success = _data["success"] ? InteractionResponse.fromJS(_data["success"]) : <any>undefined;
      this.failure = _data["failure"] ? InteractionResponse.fromJS(_data["failure"]) : <any>undefined;
      if (Array.isArray(_data["options"])) {
        this.options = [] as any;
        for (let item of _data["options"]) this.options!.push(InteractionResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): InteractionStructure {
    data = typeof data === "object" ? data : {};
    let result = new InteractionStructure();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["title"] = this.title;
    data["description"] = this.description;
    data["subType"] = this.subType;
    data["questionid"] = this.questionid;
    data["success"] = this.success ? this.success.toJSON() : <any>undefined;
    data["failure"] = this.failure ? this.failure.toJSON() : <any>undefined;
    if (Array.isArray(this.options)) {
      data["options"] = [];
      for (let item of this.options) data["options"].push(item.toJSON());
    }
    return data;
  }
}

export interface IInteractionStructure {
  id?: number;
  title?: string | undefined;
  description?: string | undefined;
  subType?: number;
  questionid?: number;
  success?: InteractionResponse;
  failure?: InteractionResponse;
  options?: InteractionResponse[] | undefined;
}

export class InteractiveVideo implements IInteractiveVideo {
  link?: string | undefined;
  provider?: string | undefined;

  constructor(data?: IInteractiveVideo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.link = _data["link"];
      this.provider = _data["provider"];
    }
  }

  static fromJS(data: any): InteractiveVideo {
    data = typeof data === "object" ? data : {};
    let result = new InteractiveVideo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["link"] = this.link;
    data["provider"] = this.provider;
    return data;
  }
}

export interface IInteractiveVideo {
  link?: string | undefined;
  provider?: string | undefined;
}

export class ItemConfiguration implements IItemConfiguration {
  type?: ItemConfigurationType;
  provider?: string | undefined;
  tempLevel?: string | undefined;
  tempSubType?: string | undefined;
  optionId?: string | undefined;
  friendlyId?: string | undefined;

  constructor(data?: IItemConfiguration) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"];
      this.provider = _data["provider"];
      this.tempLevel = _data["tempLevel"];
      this.tempSubType = _data["tempSubType"];
      this.optionId = _data["optionId"];
      this.friendlyId = _data["friendlyId"];
    }
  }

  static fromJS(data: any): ItemConfiguration {
    data = typeof data === "object" ? data : {};
    let result = new ItemConfiguration();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["type"] = this.type;
    data["provider"] = this.provider;
    data["tempLevel"] = this.tempLevel;
    data["tempSubType"] = this.tempSubType;
    data["optionId"] = this.optionId;
    data["friendlyId"] = this.friendlyId;
    return data;
  }
}

export interface IItemConfiguration {
  type?: ItemConfigurationType;
  provider?: string | undefined;
  tempLevel?: string | undefined;
  tempSubType?: string | undefined;
  optionId?: string | undefined;
  friendlyId?: string | undefined;
}

export enum ItemConfigurationType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
  _6 = 6,
  _7 = 7,
  _8 = 8,
  _9 = 9,
  _10 = 10,
  _11 = 11,
  _12 = 12,
  _13 = 13,
  _14 = 14,
  _15 = 15,
  _16 = 16,
  _17 = 17,
  _18 = 18,
  _19 = 19,
  _20 = 20,
}

export class ItemDto implements IItemDto {
  type?: ItemType;
  configuration?: ItemConfiguration;
  items?: ItemDto[] | undefined;
  value?: string | undefined;
  url?: string | undefined;
  altText?: string | undefined;
  referenceKey?: ReferenceKey;
  id?: ReferenceKey;
  learningObjectives?: string[] | undefined;
  metadata?: MetaData;

  constructor(data?: IItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"];
      this.configuration = _data["configuration"] ? ItemConfiguration.fromJS(_data["configuration"]) : <any>undefined;
      if (Array.isArray(_data["items"])) {
        this.items = [] as any;
        for (let item of _data["items"]) this.items!.push(ItemDto.fromJS(item));
      }
      this.value = _data["value"];
      this.url = _data["url"];
      this.altText = _data["altText"];
      this.referenceKey = _data["referenceKey"] ? ReferenceKey.fromJS(_data["referenceKey"]) : <any>undefined;
      this.id = _data["id"] ? ReferenceKey.fromJS(_data["id"]) : <any>undefined;
      if (Array.isArray(_data["learningObjectives"])) {
        this.learningObjectives = [] as any;
        for (let item of _data["learningObjectives"]) this.learningObjectives!.push(item);
      }
      this.metadata = _data["metadata"] ? MetaData.fromJS(_data["metadata"]) : <any>undefined;
    }
  }

  static fromJS(data: any): ItemDto {
    data = typeof data === "object" ? data : {};
    let result = new ItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["type"] = this.type;
    data["configuration"] = this.configuration ? this.configuration.toJSON() : <any>undefined;
    if (Array.isArray(this.items)) {
      data["items"] = [];
      for (let item of this.items) data["items"].push(item.toJSON());
    }
    data["value"] = this.value;
    data["url"] = this.url;
    data["altText"] = this.altText;
    data["referenceKey"] = this.referenceKey ? this.referenceKey.toJSON() : <any>undefined;
    data["id"] = this.id ? this.id.toJSON() : <any>undefined;
    if (Array.isArray(this.learningObjectives)) {
      data["learningObjectives"] = [];
      for (let item of this.learningObjectives) data["learningObjectives"].push(item);
    }
    data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
    return data;
  }
}

export interface IItemDto {
  type?: ItemType;
  configuration?: ItemConfiguration;
  items?: ItemDto[] | undefined;
  value?: string | undefined;
  url?: string | undefined;
  altText?: string | undefined;
  referenceKey?: ReferenceKey;
  id?: ReferenceKey;
  learningObjectives?: string[] | undefined;
  metadata?: MetaData;
}

export enum ItemType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _4 = 4,
  _5 = 5,
  _6 = 6,
  _7 = 7,
  _8 = 8,
  _9 = 9,
  _10 = 10,
  _11 = 11,
  _12 = 12,
  _13 = 13,
}

export class LearningObjectDto implements ILearningObjectDto {
  id?: number;
  templateId?: number;
  data?: string | undefined;

  constructor(data?: ILearningObjectDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.templateId = _data["templateId"];
      this.data = _data["data"];
    }
  }

  static fromJS(data: any): LearningObjectDto {
    data = typeof data === "object" ? data : {};
    let result = new LearningObjectDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["templateId"] = this.templateId;
    data["data"] = this.data;
    return data;
  }
}

export interface ILearningObjectDto {
  id?: number;
  templateId?: number;
  data?: string | undefined;
}

export class LearningObjectStructure implements ILearningObjectStructure {
  id?: number;
  title?: string | undefined;
  description?: string | undefined;
  subType?: ContainerSubTypeLearningObject;
  components?: Component[] | undefined;
  metadata?: CDSMetadata;

  constructor(data?: ILearningObjectStructure) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.title = _data["title"];
      this.description = _data["description"];
      this.subType = _data["subType"];
      if (Array.isArray(_data["components"])) {
        this.components = [] as any;
        for (let item of _data["components"]) this.components!.push(Component.fromJS(item));
      }
      this.metadata = _data["metadata"] ? CDSMetadata.fromJS(_data["metadata"]) : <any>undefined;
    }
  }

  static fromJS(data: any): LearningObjectStructure {
    data = typeof data === "object" ? data : {};
    let result = new LearningObjectStructure();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["title"] = this.title;
    data["description"] = this.description;
    data["subType"] = this.subType;
    if (Array.isArray(this.components)) {
      data["components"] = [];
      for (let item of this.components) data["components"].push(item.toJSON());
    }
    data["metadata"] = this.metadata ? this.metadata.toJSON() : <any>undefined;
    return data;
  }
}

export interface ILearningObjectStructure {
  id?: number;
  title?: string | undefined;
  description?: string | undefined;
  subType?: ContainerSubTypeLearningObject;
  components?: Component[] | undefined;
  metadata?: CDSMetadata;
}

export enum LifeCycleStatus {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
}

export class MediaDto implements IMediaDto {
  id?: number;
  name?: string | undefined;
  link?: string | undefined;
  linkTypeId?: number;
  linkType?: string | undefined;
  customerDto!: CustomerDto;

  constructor(data?: IMediaDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.customerDto = new CustomerDto();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.link = _data["link"];
      this.linkTypeId = _data["linkTypeId"];
      this.linkType = _data["linkType"];
      this.customerDto = _data["customerDto"] ? CustomerDto.fromJS(_data["customerDto"]) : new CustomerDto();
    }
  }

  static fromJS(data: any): MediaDto {
    data = typeof data === "object" ? data : {};
    let result = new MediaDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["link"] = this.link;
    data["linkTypeId"] = this.linkTypeId;
    data["linkType"] = this.linkType;
    data["customerDto"] = this.customerDto ? this.customerDto.toJSON() : <any>undefined;
    return data;
  }
}

export interface IMediaDto {
  id?: number;
  name?: string | undefined;
  link?: string | undefined;
  linkTypeId?: number;
  linkType?: string | undefined;
  customerDto: CustomerDto;
}

export class MediaObjectDto implements IMediaObjectDto {
  id?: number;
  mediaType?: number;
  mediaDtos?: MediaDto[] | undefined;

  constructor(data?: IMediaObjectDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.mediaType = _data["mediaType"];
      if (Array.isArray(_data["mediaDtos"])) {
        this.mediaDtos = [] as any;
        for (let item of _data["mediaDtos"]) this.mediaDtos!.push(MediaDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MediaObjectDto {
    data = typeof data === "object" ? data : {};
    let result = new MediaObjectDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["mediaType"] = this.mediaType;
    if (Array.isArray(this.mediaDtos)) {
      data["mediaDtos"] = [];
      for (let item of this.mediaDtos) data["mediaDtos"].push(item.toJSON());
    }
    return data;
  }
}

export interface IMediaObjectDto {
  id?: number;
  mediaType?: number;
  mediaDtos?: MediaDto[] | undefined;
}

export class MetaData implements IMetaData {
  source?: Source;

  constructor(data?: IMetaData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.source = _data["source"] ? Source.fromJS(_data["source"]) : <any>undefined;
    }
  }

  static fromJS(data: any): MetaData {
    data = typeof data === "object" ? data : {};
    let result = new MetaData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["source"] = this.source ? this.source.toJSON() : <any>undefined;
    return data;
  }
}

export interface IMetaData {
  source?: Source;
}

export class MyLatestItemDto implements IMyLatestItemDto {
  id?: number;
  name?: string | undefined;

  constructor(data?: IMyLatestItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): MyLatestItemDto {
    data = typeof data === "object" ? data : {};
    let result = new MyLatestItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    return data;
  }
}

export interface IMyLatestItemDto {
  id?: number;
  name?: string | undefined;
}

export class PageInfoDto implements IPageInfoDto {
  pageSize?: number;
  page?: number;
  pageCount?: number;
  rowCount?: number;

  constructor(data?: IPageInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pageSize = _data["pageSize"];
      this.page = _data["page"];
      this.pageCount = _data["pageCount"];
      this.rowCount = _data["rowCount"];
    }
  }

  static fromJS(data: any): PageInfoDto {
    data = typeof data === "object" ? data : {};
    let result = new PageInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["pageSize"] = this.pageSize;
    data["page"] = this.page;
    data["pageCount"] = this.pageCount;
    data["rowCount"] = this.rowCount;
    return data;
  }
}

export interface IPageInfoDto {
  pageSize?: number;
  page?: number;
  pageCount?: number;
  rowCount?: number;
}

export class PingResult implements IPingResult {
  response?: string | undefined;

  constructor(data?: IPingResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.response = _data["response"];
    }
  }

  static fromJS(data: any): PingResult {
    data = typeof data === "object" ? data : {};
    let result = new PingResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["response"] = this.response;
    return data;
  }
}

export interface IPingResult {
  response?: string | undefined;
}

export class PublishContainerResponse implements IPublishContainerResponse {
  success?: boolean;
  contentId?: string;
  versionId?: string;
  publishValidationErrors?: PublishValidationError[] | undefined;

  constructor(data?: IPublishContainerResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.success = _data["success"];
      this.contentId = _data["contentId"];
      this.versionId = _data["versionId"];
      if (Array.isArray(_data["publishValidationErrors"])) {
        this.publishValidationErrors = [] as any;
        for (let item of _data["publishValidationErrors"])
          this.publishValidationErrors!.push(PublishValidationError.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PublishContainerResponse {
    data = typeof data === "object" ? data : {};
    let result = new PublishContainerResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["success"] = this.success;
    data["contentId"] = this.contentId;
    data["versionId"] = this.versionId;
    if (Array.isArray(this.publishValidationErrors)) {
      data["publishValidationErrors"] = [];
      for (let item of this.publishValidationErrors) data["publishValidationErrors"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPublishContainerResponse {
  success?: boolean;
  contentId?: string;
  versionId?: string;
  publishValidationErrors?: PublishValidationError[] | undefined;
}

export enum PublishErrorType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
  _5 = 5,
}

export class PublishValidationError implements IPublishValidationError {
  id?: number;
  errorType?: PublishErrorType;

  constructor(data?: IPublishValidationError) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.errorType = _data["errorType"];
    }
  }

  static fromJS(data: any): PublishValidationError {
    data = typeof data === "object" ? data : {};
    let result = new PublishValidationError();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["errorType"] = this.errorType;
    return data;
  }
}

export interface IPublishValidationError {
  id?: number;
  errorType?: PublishErrorType;
}

export class PublishValidationResponse implements IPublishValidationResponse {
  success?: boolean;
  publishValidationErrors?: PublishValidationError[] | undefined;

  constructor(data?: IPublishValidationResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.success = _data["success"];
      if (Array.isArray(_data["publishValidationErrors"])) {
        this.publishValidationErrors = [] as any;
        for (let item of _data["publishValidationErrors"])
          this.publishValidationErrors!.push(PublishValidationError.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PublishValidationResponse {
    data = typeof data === "object" ? data : {};
    let result = new PublishValidationResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["success"] = this.success;
    if (Array.isArray(this.publishValidationErrors)) {
      data["publishValidationErrors"] = [];
      for (let item of this.publishValidationErrors) data["publishValidationErrors"].push(item.toJSON());
    }
    return data;
  }
}

export interface IPublishValidationResponse {
  success?: boolean;
  publishValidationErrors?: PublishValidationError[] | undefined;
}

export class QuestionDto implements IQuestionDto {
  id!: number;
  questionId!: number;
  questionObjectId!: number;
  name!: string;
  customerDto!: CustomerDto;

  constructor(data?: IQuestionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.customerDto = new CustomerDto();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.questionId = _data["questionId"];
      this.questionObjectId = _data["questionObjectId"];
      this.name = _data["name"];
      this.customerDto = _data["customerDto"] ? CustomerDto.fromJS(_data["customerDto"]) : new CustomerDto();
    }
  }

  static fromJS(data: any): QuestionDto {
    data = typeof data === "object" ? data : {};
    let result = new QuestionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["questionId"] = this.questionId;
    data["questionObjectId"] = this.questionObjectId;
    data["name"] = this.name;
    data["customerDto"] = this.customerDto ? this.customerDto.toJSON() : <any>undefined;
    return data;
  }
}

export interface IQuestionDto {
  id: number;
  questionId: number;
  questionObjectId: number;
  name: string;
  customerDto: CustomerDto;
}

export class QuestionObjectDto implements IQuestionObjectDto {
  id!: number;
  questionType!: number;
  questionDtos!: QuestionDto[];

  constructor(data?: IQuestionObjectDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.questionDtos = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.questionType = _data["questionType"];
      if (Array.isArray(_data["questionDtos"])) {
        this.questionDtos = [] as any;
        for (let item of _data["questionDtos"]) this.questionDtos!.push(QuestionDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): QuestionObjectDto {
    data = typeof data === "object" ? data : {};
    let result = new QuestionObjectDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["questionType"] = this.questionType;
    if (Array.isArray(this.questionDtos)) {
      data["questionDtos"] = [];
      for (let item of this.questionDtos) data["questionDtos"].push(item.toJSON());
    }
    return data;
  }
}

export interface IQuestionObjectDto {
  id: number;
  questionType: number;
  questionDtos: QuestionDto[];
}

export class Reference implements IReference {
  contentId?: string;
  versionId?: string;

  constructor(data?: IReference) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contentId = _data["contentId"];
      this.versionId = _data["versionId"];
    }
  }

  static fromJS(data: any): Reference {
    data = typeof data === "object" ? data : {};
    let result = new Reference();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["contentId"] = this.contentId;
    data["versionId"] = this.versionId;
    return data;
  }
}

export interface IReference {
  contentId?: string;
  versionId?: string;
}

export class ReferenceKey implements IReferenceKey {
  contentId?: string;
  versionId?: string | undefined;

  constructor(data?: IReferenceKey) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contentId = _data["contentId"];
      this.versionId = _data["versionId"];
    }
  }

  static fromJS(data: any): ReferenceKey {
    data = typeof data === "object" ? data : {};
    let result = new ReferenceKey();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["contentId"] = this.contentId;
    data["versionId"] = this.versionId;
    return data;
  }
}

export interface IReferenceKey {
  contentId?: string;
  versionId?: string | undefined;
}

export class SaveContainerRequest implements ISaveContainerRequest {
  containerClassifications?: ContainerClassificationDto[] | undefined;
  containerLearningObjectives?: ContainerLearningObjectiveDto[] | undefined;
  lifeCycleStatus?: number;
  deprecated?: boolean;
  customerId?: string;
  comment?: string | undefined;

  constructor(data?: ISaveContainerRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["containerClassifications"])) {
        this.containerClassifications = [] as any;
        for (let item of _data["containerClassifications"])
          this.containerClassifications!.push(ContainerClassificationDto.fromJS(item));
      }
      if (Array.isArray(_data["containerLearningObjectives"])) {
        this.containerLearningObjectives = [] as any;
        for (let item of _data["containerLearningObjectives"])
          this.containerLearningObjectives!.push(ContainerLearningObjectiveDto.fromJS(item));
      }
      this.lifeCycleStatus = _data["lifeCycleStatus"];
      this.deprecated = _data["deprecated"];
      this.customerId = _data["customerId"];
      this.comment = _data["comment"];
    }
  }

  static fromJS(data: any): SaveContainerRequest {
    data = typeof data === "object" ? data : {};
    let result = new SaveContainerRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.containerClassifications)) {
      data["containerClassifications"] = [];
      for (let item of this.containerClassifications) data["containerClassifications"].push(item.toJSON());
    }
    if (Array.isArray(this.containerLearningObjectives)) {
      data["containerLearningObjectives"] = [];
      for (let item of this.containerLearningObjectives) data["containerLearningObjectives"].push(item.toJSON());
    }
    data["lifeCycleStatus"] = this.lifeCycleStatus;
    data["deprecated"] = this.deprecated;
    data["customerId"] = this.customerId;
    data["comment"] = this.comment;
    return data;
  }
}

export interface ISaveContainerRequest {
  containerClassifications?: ContainerClassificationDto[] | undefined;
  containerLearningObjectives?: ContainerLearningObjectiveDto[] | undefined;
  lifeCycleStatus?: number;
  deprecated?: boolean;
  customerId?: string;
  comment?: string | undefined;
}

export class SaveInteractionContainerRequest implements ISaveInteractionContainerRequest {
  interactionContainer?: ContainerDto;
  interactionStructure?: InteractionStructure;

  constructor(data?: ISaveInteractionContainerRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.interactionContainer = _data["interactionContainer"]
        ? ContainerDto.fromJS(_data["interactionContainer"])
        : <any>undefined;
      this.interactionStructure = _data["interactionStructure"]
        ? InteractionStructure.fromJS(_data["interactionStructure"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): SaveInteractionContainerRequest {
    data = typeof data === "object" ? data : {};
    let result = new SaveInteractionContainerRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["interactionContainer"] = this.interactionContainer ? this.interactionContainer.toJSON() : <any>undefined;
    data["interactionStructure"] = this.interactionStructure ? this.interactionStructure.toJSON() : <any>undefined;
    return data;
  }
}

export interface ISaveInteractionContainerRequest {
  interactionContainer?: ContainerDto;
  interactionStructure?: InteractionStructure;
}

export class Source implements ISource {
  id?: string | undefined;
  identifier?: string | undefined;
  name?: string | undefined;

  constructor(data?: ISource) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.identifier = _data["identifier"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): Source {
    data = typeof data === "object" ? data : {};
    let result = new Source();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["identifier"] = this.identifier;
    data["name"] = this.name;
    return data;
  }
}

export interface ISource {
  id?: string | undefined;
  identifier?: string | undefined;
  name?: string | undefined;
}

export class TextDto implements ITextDto {
  id?: number;
  textObjectId?: number;
  text?: string | undefined;
  customerDto!: CustomerDto;

  constructor(data?: ITextDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.customerDto = new CustomerDto();
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.textObjectId = _data["textObjectId"];
      this.text = _data["text"];
      this.customerDto = _data["customerDto"] ? CustomerDto.fromJS(_data["customerDto"]) : new CustomerDto();
    }
  }

  static fromJS(data: any): TextDto {
    data = typeof data === "object" ? data : {};
    let result = new TextDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["textObjectId"] = this.textObjectId;
    data["text"] = this.text;
    data["customerDto"] = this.customerDto ? this.customerDto.toJSON() : <any>undefined;
    return data;
  }
}

export interface ITextDto {
  id?: number;
  textObjectId?: number;
  text?: string | undefined;
  customerDto: CustomerDto;
}

export class TextObjectDto implements ITextObjectDto {
  id?: number;
  textType?: number;
  textDtos?: TextDto[] | undefined;

  constructor(data?: ITextObjectDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.textType = _data["textType"];
      if (Array.isArray(_data["textDtos"])) {
        this.textDtos = [] as any;
        for (let item of _data["textDtos"]) this.textDtos!.push(TextDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): TextObjectDto {
    data = typeof data === "object" ? data : {};
    let result = new TextObjectDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["textType"] = this.textType;
    if (Array.isArray(this.textDtos)) {
      data["textDtos"] = [];
      for (let item of this.textDtos) data["textDtos"].push(item.toJSON());
    }
    return data;
  }
}

export interface ITextObjectDto {
  id?: number;
  textType?: number;
  textDtos?: TextDto[] | undefined;
}

export class UserDto implements IUserDto {
  id?: number;
  externalId?: string;
  name?: string | undefined;
  link?: string | undefined;
  rights?: string[] | undefined;
  groupDtos?: GroupDto[] | undefined;
  jwtBearerToken?: string | undefined;
  roles?: string[] | undefined;

  constructor(data?: IUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.externalId = _data["externalId"];
      this.name = _data["name"];
      this.link = _data["link"];
      if (Array.isArray(_data["rights"])) {
        this.rights = [] as any;
        for (let item of _data["rights"]) this.rights!.push(item);
      }
      if (Array.isArray(_data["groupDtos"])) {
        this.groupDtos = [] as any;
        for (let item of _data["groupDtos"]) this.groupDtos!.push(GroupDto.fromJS(item));
      }
      this.jwtBearerToken = _data["jwtBearerToken"];
      if (Array.isArray(_data["roles"])) {
        this.roles = [] as any;
        for (let item of _data["roles"]) this.roles!.push(item);
      }
    }
  }

  static fromJS(data: any): UserDto {
    data = typeof data === "object" ? data : {};
    let result = new UserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["externalId"] = this.externalId;
    data["name"] = this.name;
    data["link"] = this.link;
    if (Array.isArray(this.rights)) {
      data["rights"] = [];
      for (let item of this.rights) data["rights"].push(item);
    }
    if (Array.isArray(this.groupDtos)) {
      data["groupDtos"] = [];
      for (let item of this.groupDtos) data["groupDtos"].push(item.toJSON());
    }
    data["jwtBearerToken"] = this.jwtBearerToken;
    if (Array.isArray(this.roles)) {
      data["roles"] = [];
      for (let item of this.roles) data["roles"].push(item);
    }
    return data;
  }
}

export interface IUserDto {
  id?: number;
  externalId?: string;
  name?: string | undefined;
  link?: string | undefined;
  rights?: string[] | undefined;
  groupDtos?: GroupDto[] | undefined;
  jwtBearerToken?: string | undefined;
  roles?: string[] | undefined;
}

export class Video implements IVideo {
  link?: string | undefined;
  provider?: string | undefined;
  name?: string | undefined;

  constructor(data?: IVideo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.link = _data["link"];
      this.provider = _data["provider"];
      this.name = _data["name"];
    }
  }

  static fromJS(data: any): Video {
    data = typeof data === "object" ? data : {};
    let result = new Video();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["link"] = this.link;
    data["provider"] = this.provider;
    data["name"] = this.name;
    return data;
  }
}

export interface IVideo {
  link?: string | undefined;
  provider?: string | undefined;
  name?: string | undefined;
}

export class WhereUsedDto implements IWhereUsedDto {
  id?: number;
  name?: string | undefined;
  published?: boolean;
  type?: WhereUsedType;
  status?: number;
  classificationIds?: string[] | undefined;

  constructor(data?: IWhereUsedDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.name = _data["name"];
      this.published = _data["published"];
      this.type = _data["type"];
      this.status = _data["status"];
      if (Array.isArray(_data["classificationIds"])) {
        this.classificationIds = [] as any;
        for (let item of _data["classificationIds"]) this.classificationIds!.push(item);
      }
    }
  }

  static fromJS(data: any): WhereUsedDto {
    data = typeof data === "object" ? data : {};
    let result = new WhereUsedDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["name"] = this.name;
    data["published"] = this.published;
    data["type"] = this.type;
    data["status"] = this.status;
    if (Array.isArray(this.classificationIds)) {
      data["classificationIds"] = [];
      for (let item of this.classificationIds) data["classificationIds"].push(item);
    }
    return data;
  }
}

export interface IWhereUsedDto {
  id?: number;
  name?: string | undefined;
  published?: boolean;
  type?: WhereUsedType;
  status?: number;
  classificationIds?: string[] | undefined;
}

export class WhereUsedLearningObjectImageRequest implements IWhereUsedLearningObjectImageRequest {
  contentId?: string;
  versionId?: string;

  constructor(data?: IWhereUsedLearningObjectImageRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contentId = _data["contentId"];
      this.versionId = _data["versionId"];
    }
  }

  static fromJS(data: any): WhereUsedLearningObjectImageRequest {
    data = typeof data === "object" ? data : {};
    let result = new WhereUsedLearningObjectImageRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["contentId"] = this.contentId;
    data["versionId"] = this.versionId;
    return data;
  }
}

export interface IWhereUsedLearningObjectImageRequest {
  contentId?: string;
  versionId?: string;
}

export class WhereUsedQuestionRequest implements IWhereUsedQuestionRequest {
  id?: number;
  contentId?: string | undefined;
  versionId?: string | undefined;
  classificationIds?: string[] | undefined;

  constructor(data?: IWhereUsedQuestionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.contentId = _data["contentId"];
      this.versionId = _data["versionId"];
      if (Array.isArray(_data["classificationIds"])) {
        this.classificationIds = [] as any;
        for (let item of _data["classificationIds"]) this.classificationIds!.push(item);
      }
    }
  }

  static fromJS(data: any): WhereUsedQuestionRequest {
    data = typeof data === "object" ? data : {};
    let result = new WhereUsedQuestionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["contentId"] = this.contentId;
    data["versionId"] = this.versionId;
    if (Array.isArray(this.classificationIds)) {
      data["classificationIds"] = [];
      for (let item of this.classificationIds) data["classificationIds"].push(item);
    }
    return data;
  }
}

export interface IWhereUsedQuestionRequest {
  id?: number;
  contentId?: string | undefined;
  versionId?: string | undefined;
  classificationIds?: string[] | undefined;
}

export enum WhereUsedType {
  _0 = 0,
  _1 = 1,
  _2 = 2,
  _3 = 3,
  _4 = 4,
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
